///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-category.ts"/>


module Meevo.Components.Controls.SmartMover {


    import DP005ProductCategory = Meevo.Plugins.Reports.DP005ProductCategory;
    import DP005ProductManufecturer = Meevo.Plugins.Reports.DP005ProductManufecturer;
    import IReportManufacturers = Meevo.Plugins.Reports.IReportManufacturers;

    export class ManufacturersToProductCatStrategy implements ICollectionPopulate {
        constructor(private productCategories: ICollectionBase<DP005ProductCategory>,
                    private manufacturers: ICollectionBase<DP005ProductManufecturer>) {
        }

        populate(): void {
            if (this.productCategories.models.length === 0) {
                return;
            }

            for (const category of this.productCategories.models) {
                (<ISmartMoverCategoryModel<IReportManufacturers>>category).resetModels(
                    this.manufacturers.models.filter(manufacturer => category.id === manufacturer.get('category_TId'))
                );
            }
        }
    }
}